import { baseConfig } from "./environment.base";
// Environment config for the production environment
baseConfig.production = true;
baseConfig.rollbar.enabled = true;
baseConfig.rollbar.environment = "production";
baseConfig.displayUncaughtErrorMessage = false;
export const environment = baseConfig;
